export class CostReviewEquipmentSa{
    numberOfBuildings: number = 0;
    breakoutByArea: number = 0;
    detailedEquipmentList: number = 0;
    equipmentManufacturer: number = 0;
    consumablesIncluded: number[] = [];
    isConsumableIncludedOtherChecked: boolean = false;
    otherConsumables: string = "";
    consumablesDetailedQuotes: number = 0;
    procurementEngaged: number = 0;
}